// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stb {
  width: 99%;
  border-collapse: collapse;
  margin-top: 40px;
  margin-left: 10px;
}

.Wtd {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 10px 5px 10px 10px !important;
  text-align: left;
}

.Wth {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  padding: 14px 5px 14px 10px !important;
  text-align: left;
}

.Wthh {
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 16px;
  border-bottom: 1px solid #efefef !important;
  /* padding: 14px 5px 14px 20px !important; */
  text-align: left;
}

tr:hover {
  background-color: #f2f2f2;
}

/* h2 {
    font-size: 20px;
    margin-bottom: 10px;
} */

/* .searchbars {
  border: 1px solid #ccc;
  height: 33px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 20px;
  margin-top: -50px;
  width: 150px; 
  padding: 0 10px;
  margin-left: 30%;
} */

.searchbar:hover {
  border-color: #ccc;
}

.uploadS {
  align-items: center;
  margin-right: 5%; /* Add some margin */
  margin-left: 10px; /* Add some margin */
  margin-top: 0.4%;
  border-radius: 50px;
}

.choose-file-button {
  height: 30px;
  width: 150px;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  border: 1px solid lightgray;
  border-radius: 6px;
}

/* Container for search input and date picker */
.boxesS {
  display: flex;
  align-items: center; /* Vertically align items */
  gap: 10px; /* Space between items */
  margin-left: 20%;
}

/* Styling for the search input */
.searchbars {
  margin-left: 800px;
  height: 40px; /* Adjust height to match the DatePicker */
  padding: 0 10px; /* Padding inside the input */
  border: 1px solid #ccc; /* Border styling */
  border-radius: 4px; /* Rounded corners */
  font-size: 16px; /* Font size for input text */
  width: 200px; /* Set desired width for the search input */
}

/* Styling for the DatePicker */
.dropdown {
  height: 40px; /* Ensure it matches the search input height */
  border: 1px solid #ccc; /* Border styling */
  border-radius: 4px; /* Rounded corners */
  font-size: 16px; /* Font size for date text */
}

/* Responsive Media Queries */
@media (max-width: 1024px) {
  .dropdown {
    margin: 10px auto; /* Center elements on smaller screens */
    width: 80%; /* Adjust width */
  }
  .searchbars {
    margin: 10px auto; /* Center elements on smaller screens */
    width: 80%; /* Adjust width */
  }

  .boxesS {
    flex-wrap: wrap;
    justify-content: center; /* Center items horizontally */
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .dropdown {
    width: 116%; /* Full-width on smaller screens */
    margin-left: 0;
    margin-right: 0;
  }
  .searchbars {
    width: 100%; /* Full-width on smaller screens */
    margin-left: 0;
    margin-right: 0;
  }

  .boxesS {
    justify-content: space-evenly; /* Evenly distribute items horizontally */
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .dropdown {
    width: 100%; /* Full-width for mobile screens */
    margin-left: 0;
    margin-right: 0;
  }
  .searchbars {
    width: 94%; /* Full-width for mobile screens */
    margin-left: 0;
    margin-right: 0;
  }

  .boxesS {
    flex-wrap: wrap;
    justify-content: space-between; /* Adjust items horizontally */
    margin-top: 15px;
    padding: 0 5px;
  }
}

.bS {
  cursor: pointer;
  border-radius: 6px;
  border: none;
  background-color: #79c6e9;
  font-size: 13px;
  padding-left: 5px;
  padding-right: 5px;
}

@media only screen and (max-width: 768px) {
  table {
    margin-top: 25px;
  }

  th,
  td {
    padding: 6px;
  }

  th {
    font-size: 14px;
  }

  /* h2 {
    font-size: 18px;
  } */

  .bS {
    font-size: 12px;
  }
}

.react-datepicker {
  font-size: 12px !important; /* Shrinks text */
  transform: scale(0.85); /* Shrinks whole calendar */
  transform-origin: top left; /* Keeps alignment */
}
`, "",{"version":3,"sources":["webpack://./src/Css/WorkHoursTable.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,2CAA2C;EAC3C,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;GAGG;;AAEH;;;;;;;;;;;;GAYG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB,EAAE,oBAAoB;EACtC,iBAAiB,EAAE,oBAAoB;EACvC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oEAAoE;EACpE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB,EAAE,2BAA2B;EAChD,SAAS,EAAE,wBAAwB;EACnC,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,eAAe,EAAE,6BAA6B;EAC9C,sBAAsB,EAAE,mBAAmB;EAC3C,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,6BAA6B;EAC9C,YAAY,EAAE,2CAA2C;AAC3D;;AAEA,+BAA+B;AAC/B;EACE,YAAY,EAAE,8CAA8C;EAC5D,sBAAsB,EAAE,mBAAmB;EAC3C,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,4BAA4B;AAC/C;;AAEA,6BAA6B;AAC7B;EACE;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,UAAU,EAAE,iBAAiB;EAC/B;EACA;IACE,iBAAiB,EAAE,uCAAuC;IAC1D,UAAU,EAAE,iBAAiB;EAC/B;;EAEA;IACE,eAAe;IACf,uBAAuB,EAAE,8BAA8B;IACvD,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW,EAAE,kCAAkC;IAC/C,cAAc;IACd,eAAe;EACjB;EACA;IACE,WAAW,EAAE,kCAAkC;IAC/C,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,6BAA6B,EAAE,yCAAyC;IACxE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW,EAAE,kCAAkC;IAC/C,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU,EAAE,kCAAkC;IAC9C,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,8BAA8B,EAAE,8BAA8B;IAC9D,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;KAEG;;EAEH;IACE,eAAe;EACjB;AACF;;AAEA;EACE,0BAA0B,EAAE,iBAAiB;EAC7C,sBAAsB,EAAE,2BAA2B;EACnD,0BAA0B,EAAE,oBAAoB;AAClD","sourcesContent":[".Stb {\r\n  width: 99%;\r\n  border-collapse: collapse;\r\n  margin-top: 40px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.Wtd {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 10px 5px 10px 10px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Wth {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  padding: 14px 5px 14px 10px !important;\r\n  text-align: left;\r\n}\r\n\r\n.Wthh {\r\n  font-size: 14px !important;\r\n  font-weight: 500 !important;\r\n  line-height: 16px;\r\n  border-bottom: 1px solid #efefef !important;\r\n  /* padding: 14px 5px 14px 20px !important; */\r\n  text-align: left;\r\n}\r\n\r\ntr:hover {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n/* h2 {\r\n    font-size: 20px;\r\n    margin-bottom: 10px;\r\n} */\r\n\r\n/* .searchbars {\r\n  border: 1px solid #ccc;\r\n  height: 33px;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 15px;\r\n  line-height: 20px;\r\n  margin-top: -50px;\r\n  width: 150px; \r\n  padding: 0 10px;\r\n  margin-left: 30%;\r\n} */\r\n\r\n.searchbar:hover {\r\n  border-color: #ccc;\r\n}\r\n\r\n.uploadS {\r\n  align-items: center;\r\n  margin-right: 5%; /* Add some margin */\r\n  margin-left: 10px; /* Add some margin */\r\n  margin-top: 0.4%;\r\n  border-radius: 50px;\r\n}\r\n\r\n.choose-file-button {\r\n  height: 30px;\r\n  width: 150px;\r\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\r\n  border: 1px solid lightgray;\r\n  border-radius: 6px;\r\n}\r\n\r\n/* Container for search input and date picker */\r\n.boxesS {\r\n  display: flex;\r\n  align-items: center; /* Vertically align items */\r\n  gap: 10px; /* Space between items */\r\n  margin-left: 20%;\r\n}\r\n\r\n/* Styling for the search input */\r\n.searchbars {\r\n  margin-left: 800px;\r\n  height: 40px; /* Adjust height to match the DatePicker */\r\n  padding: 0 10px; /* Padding inside the input */\r\n  border: 1px solid #ccc; /* Border styling */\r\n  border-radius: 4px; /* Rounded corners */\r\n  font-size: 16px; /* Font size for input text */\r\n  width: 200px; /* Set desired width for the search input */\r\n}\r\n\r\n/* Styling for the DatePicker */\r\n.dropdown {\r\n  height: 40px; /* Ensure it matches the search input height */\r\n  border: 1px solid #ccc; /* Border styling */\r\n  border-radius: 4px; /* Rounded corners */\r\n  font-size: 16px; /* Font size for date text */\r\n}\r\n\r\n/* Responsive Media Queries */\r\n@media (max-width: 1024px) {\r\n  .dropdown {\r\n    margin: 10px auto; /* Center elements on smaller screens */\r\n    width: 80%; /* Adjust width */\r\n  }\r\n  .searchbars {\r\n    margin: 10px auto; /* Center elements on smaller screens */\r\n    width: 80%; /* Adjust width */\r\n  }\r\n\r\n  .boxesS {\r\n    flex-wrap: wrap;\r\n    justify-content: center; /* Center items horizontally */\r\n    margin-top: 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .dropdown {\r\n    width: 116%; /* Full-width on smaller screens */\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n  .searchbars {\r\n    width: 100%; /* Full-width on smaller screens */\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .boxesS {\r\n    justify-content: space-evenly; /* Evenly distribute items horizontally */\r\n    margin-top: 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dropdown {\r\n    width: 100%; /* Full-width for mobile screens */\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n  .searchbars {\r\n    width: 94%; /* Full-width for mobile screens */\r\n    margin-left: 0;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .boxesS {\r\n    flex-wrap: wrap;\r\n    justify-content: space-between; /* Adjust items horizontally */\r\n    margin-top: 15px;\r\n    padding: 0 5px;\r\n  }\r\n}\r\n\r\n.bS {\r\n  cursor: pointer;\r\n  border-radius: 6px;\r\n  border: none;\r\n  background-color: #79c6e9;\r\n  font-size: 13px;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n\r\n@media only screen and (max-width: 768px) {\r\n  table {\r\n    margin-top: 25px;\r\n  }\r\n\r\n  th,\r\n  td {\r\n    padding: 6px;\r\n  }\r\n\r\n  th {\r\n    font-size: 14px;\r\n  }\r\n\r\n  /* h2 {\r\n    font-size: 18px;\r\n  } */\r\n\r\n  .bS {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n.react-datepicker {\r\n  font-size: 12px !important; /* Shrinks text */\r\n  transform: scale(0.85); /* Shrinks whole calendar */\r\n  transform-origin: top left; /* Keeps alignment */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
